
import { mapState } from 'vuex'

export default {
  name: 'BannerTop',
  data() {
    return {
      isVisible: false
    }
  },
  computed: {
    ...mapState({
      setting: state => state.setting
    }),
    bannerUrl() {
      if (!this.setting || !this.setting.ad_banners) return null
      return this.$device.isMobile ? this.setting.ad_banners.image_sp_url : this.setting.ad_banners.image_url
    },
    bannerLink() {
      return this.setting?.ad_banners?.link || '#'
    },
    bannerStyle() {
      return {}
    }
  },
  mounted() {
    const isClosed = sessionStorage.getItem('top_banner_closed')
    if (!isClosed) {
      this.isVisible = true
      this.$emit('show')
      this.updateHeight()
      window.addEventListener('resize', this.updateHeight)
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateHeight)
  },
  methods: {
    closeBanner() {
      this.isVisible = false
      sessionStorage.setItem('top_banner_closed', 'true')
      document.documentElement.style.removeProperty('--banner-height')
      this.$emit('close')
    },
    updateHeight() {
      this.$nextTick(() => {
        if (this.$el && this.isVisible) {
          const height = this.$el.offsetHeight
          document.documentElement.style.setProperty('--banner-height', `${height}px`)
        }
      })
    }
  }
}
